<template>
  <div class="solution-filter">
    <div class="filter-group">
      <input
        type="text"
        v-model="searchParams.keyword"
        placeholder="搜索解决方案标题"
        class="search-input"
      />
    </div>
    <div class="filter-group">
      <select v-model="searchParams.category" class="filter-select">
        <option value="">所有类别</option>
        <!-- 动态选项可以根据实际数据添加 -->
      </select>
    </div>
    <div class="filter-group">
      <button @click="handleSearch" class="search-btn">搜索</button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';

const emit = defineEmits(['search']);
const searchParams = ref({
  keyword: '',
  category: ''
});

const handleSearch = () => {
  emit('search', { ...searchParams.value });
};
</script>

<style scoped>
.solution-filter {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
}

.search-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 200px;
}

.filter-select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.search-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
</style>